import './component.scss'

// 画像を一括で読み込み（457件）
const images = require.context('./images', false, /\.png$/)
images.keys().forEach(images)
